import React, { useState, useEffect } from "react";
import { Typography, Form, Input, Row, Col, Spin } from "antd";
import {
  IconCircleCheckFilled,
  IconShield,
  IconLock,
} from "@tabler/icons-react";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import { handleUpdateErrorsOfOrderCreamForm } from "../redux-toolkit/slices/orderCreamSlice";
import { createPaymentIntentApi } from "../api/createPaymentIntent";
import ErrorList from "../components/Items/ErrorsList";
import { useNavigate } from "react-router-dom";
const STRIPE_PUBLIC_KEY = `pk_test_51On47kK9EBHoL24tR19Sqer07rKMhC2niUdHW8b6U3E2IwW8z6DSSFNFAgeqHdLRQMMY5I345Vy6pXdc2qpoPPdH00UIfnK9YR`;
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
function PaymentPageInner() {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [form] = Form.useForm();
  const [phoneValue, setPhoneValue] = useState("");
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isError, errors } = useSelector(
    (state: RootState) => state.orderCream
  );
  const { userProfile } = useSelector((state: RootState) => state.auth) as {
    userProfile: IUserProfile | null;
  };

  // Initialize form values when userProfile loads
  useEffect(() => {
    if (userProfile) {
      // Set phone value for the controlled input
      if (userProfile.phoneNumber) {
        setPhoneValue(userProfile.phoneNumber);
      }

      // Update form fields with user profile data
      form.setFieldsValue({
        firstName: userProfile.firstName || "",
        lastName: userProfile.lastName || "",
        phoneNumber: userProfile.phoneNumber || "",
        street1: userProfile.address?.street1 || "",
        street2: userProfile.address?.street2 || "",
        city: userProfile.address?.city || "",
        state: userProfile.address?.state || "",
        zipCode: userProfile.address?.zipCode || "",
      });
    }
  }, [userProfile, form]);

  const onFinish = async (values: any) => {
    if (!stripe || !elements) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: [`Stripe is not loaded yet`],
        })
      );
    }
    const cardNumberElement = elements.getElement(CardNumberElement);
    const cardExpiryElement = elements.getElement(CardExpiryElement);
    const cardCvcElement = elements.getElement(CardCvcElement);

    if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: [`Stripe is not loaded yet`],
        })
      );
    }
    try {
      setIsSubmitting(true);
      // Step 1: Request PaymentIntent from backend
const dataToSend = {
        shippingDetails: {
          amount: 199,
          firstName: values.firstName,
          lastName: values.lastName,
          email: userProfile?.email,
          phoneNumber: values.phoneNumber,
          address: {
            street1: values.street1,
            street2: values.street2,
            city: values.city,
            zipCode: values.zipCode,
            state: values.state,
          },
        },
      };
      const response = await createPaymentIntentApi(dataToSend);
      const { responseData } = response;
      const { client_secret } = responseData.paymentIntent;
      const {
        firstName,
        lastName,
        phoneNumber,
        street1,
        street2,
        city,
        zipCode,
        state,
      } = values;
      const customerName =
        firstName && lastName ? `${firstName} ${lastName}` : "Customer";
      const { paymentIntent, error } = await stripe.confirmCardPayment(
        client_secret,
        {
          payment_method: {
            card: cardNumberElement,
            billing_details: {
              name: customerName,
              email: userProfile?.email || "noemail@gmail.com",
              phone: phoneNumber || undefined,
              address: {
                line1: street1 || undefined,
                line2: street2 || undefined,
                city: city || undefined,
                state: state || undefined,
                postal_code: zipCode || undefined,
                country: "US",
              },
            },
          },
        }
      );
      if (error) {
        setIsSubmitting(false);
        return dispatch(
          handleUpdateErrorsOfOrderCreamForm({
            isError: true,
            errors: [error.message || "Error while stripe payment"],
          })
        );
      }
      console.log({ paymentIntent });
      if (
        paymentIntent &&
        paymentIntent.status === "succeeded" &&
        paymentIntent.id
      ) {
        setIsSubmitting(false);
        navigate(
          `/order-cream?paymentId=${paymentIntent.id}&email=${userProfile?.email}&firstName=${firstName}&lastName=${lastName}&phoneNumber=${phoneNumber}&street1=${street1}&street2=${street2}&city=${city}&state=${state}&zipCode=${zipCode}`
        );
        // lets send user to submit his order details.
      }
    } catch (error) {
      setIsSubmitting(false);
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: [`Error While Payment through stripe`],
        })
      );

      //  openNotification("error", "Payment Error", error.message);
    }
  };

  const onFinishFailed = (data: any) => {
    console.log("Form validation failed:", data);
  };

  return (
    <>
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div className="common-section">
        <div className="container px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center py-8">
            {/* Two Column Layout */}
            <div
              className="w-full max-w-6xl grid grid-cols-1 lg:grid-cols-2 gap-6"
              style={{ gridAutoRows: "max-content" }}
            >
              {/* Left Column - Order Summary */}
              <div
                className="login-form-container rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden relative w-full"
                style={{ backgroundColor: "var(--neutral-100)" }}
              >
                <div
                  className="header-content mb-6"
                  style={{ textAlign: "left" }}
                >
                  <h2 className="h2 mb-2" style={{ textAlign: "left" }}>
                    Order Summary
                  </h2>
                  <Typography
                    className="h6 text-theme-text-secondary"
                    style={{
                      border: "1px solid var(--neutral-600)",
                      padding: "6px 16px",
                      borderRadius: "9999px",
                      lineHeight: "1",
                      display: "inline-block",
                      textAlign: "left",
                    }}
                  >
                    Here is what's included in your order{" "}
                  </Typography>
                </div>

                <div className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-1.5 h-1.5 bg-primary-500 rounded-full"></div>
                      <Typography className="h5 text-theme-text-primary">
                        x 1 Custom formula pain cream made just for{" "}
                        {userProfile?.firstName || "you"}
                      </Typography>
                    </div>

                    <div className="grid grid-cols-2 gap-6">
                      {/* Left Column - Image */}
                      <div className="flex justify-center items-start">
                        <img
                          src="/twinge-pain-relief-cream.webp"
                          alt="Twinge Pain Relief Cream"
                          className="rounded-lg animate-fade-in-up"
                          style={{
                            animation: "fadeInUp 0.6s ease-out forwards",
                            opacity: 0,
                            transform: "translateY(20px)",
                            width: "200px",
                            height: "auto",
                          }}
                        />
                      </div>

                      {/* Right Column - Checkmarks */}
                      <div className="pl-4">
                        <div className="flex items-start gap-3 mb-5">
                          <div className="flex-shrink-0 mt-0.5">
                            <IconCircleCheckFilled size={16} />
                          </div>
                          <Typography className="body1 leading-relaxed">
                            <strong>
                              Your Physician Telehealth Consultation: Expert
                              guidance from a licensed physician who will review
                              your symptoms and customize your pain relief
                              formula. You'll get a personalized treatment plan
                              without leaving your home.
                            </strong>
                          </Typography>
                        </div>
                        <div className="flex items-start gap-3 mb-5">
                          <div className="flex-shrink-0 mt-0.5">
                            <IconCircleCheckFilled size={16} />
                          </div>
                          <Typography className="body1 leading-relaxed">
                            <strong>
                              1 month supply of pain cream in a convenient,
                              easy, easy to use, mess free metered dose
                              applicator
                            </strong>
                          </Typography>
                        </div>
                        <div className="flex items-start gap-3 mb-5">
                          <div className="flex-shrink-0 mt-0.5">
                            <IconCircleCheckFilled size={16} />
                          </div>
                          <Typography className="body1 leading-relaxed">
                            <strong>
                              Pain cream tailored to your specific pain
                              condition
                            </strong>
                          </Typography>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="flex-shrink-0 mt-0.5">
                            <IconCircleCheckFilled size={16} />
                          </div>
                          <Typography className="body1 leading-relaxed">
                            <strong>
                              Ships free with USPS Priority 2 day mail.
                            </strong>
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Total Price */}
                  <div
                    className="mt-6 pt-6 border-t border-neutral-200"
                    style={{ marginTop: "12px", paddingTop: "24px" }}
                  >
                    <div className="text-center">
                      <Typography className="h4 text-theme-text-primary">
                        <strong>Total Price $79/month supply</strong>
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Billing Information Form */}
              <div
                className="login-form-container rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden relative w-full"
                style={{ backgroundColor: "var(--neutral-100)" }}
              >
                <div
                  className="header-content mb-6"
                  style={{ textAlign: "left" }}
                >
                  <h2 className="h2 mb-2" style={{ textAlign: "left" }}>
                    Billing Information
                  </h2>
                  <Typography
                    className="h6 text-theme-text-secondary"
                    style={{
                      border: "1px solid var(--neutral-600)",
                      padding: "6px 16px",
                      borderRadius: "9999px",
                      lineHeight: "1",
                      display: "inline-block",
                      textAlign: "left",
                    }}
                  >
                    Complete your billing details
                  </Typography>
                </div>

                {/* Security and Compliance Icons */}
                <div className="flex justify-start gap-6 mb-6">
                  <div className="flex items-center gap-2">
                    <IconShield size={20} className="text-primary-500" />
                    <Typography className="body2 text-theme-text-secondary">
                      HIPAA Compliant
                    </Typography>
                  </div>
                  <div className="flex items-center gap-2">
                    <IconLock size={20} className="text-primary-500" />
                    <Typography className="body2 text-theme-text-secondary">
                      Secure Payments
                    </Typography>
                    <div className="flex items-center gap-2 ml-3">
                      {/* Visa Logo */}
                      <div
                        className="w-10 h-6 bg-white rounded border border-gray-200 flex items-center justify-center"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="20"
                          viewBox="0 0 32 20"
                          style={{ display: "block" }}
                        >
                          <rect
                            x="0"
                            y="2"
                            width="32"
                            height="16"
                            rx="2"
                            fill="#1434cb"
                          ></rect>
                          <path
                            d="m13.392,7.624l-2.838,6.77h-1.851l-1.397-5.403c-.085-.332-.158-.454-.416-.595-.421-.229-1.117-.443-1.728-.576l.041-.196h2.98c.38,0,.721.253.808.69l.738,3.918,1.822-4.608h1.84Z"
                            fill="#fff"
                          ></path>
                          <path
                            d="m20.646,12.183c.008-1.787-2.47-1.886-2.453-2.684.005-.243.237-.501.743-.567.251-.032.943-.058,1.727.303l.307-1.436c-.421-.152-.964-.299-1.638-.299-1.732,0-2.95.92-2.959,2.238-.011.975.87,1.518,1.533,1.843.683.332.912.545.909.841-.005.454-.545.655-1.047.663-.881.014-1.392-.238-1.799-.428l-.318,1.484c.41.188,1.165.351,1.947.359,1.841,0,3.044-.909,3.05-2.317"
                            fill="#fff"
                          ></path>
                          <path
                            d="m25.423,7.624h-1.494c-.337,0-.62.195-.746.496l-2.628,6.274h1.839l.365-1.011h2.247l.212,1.011h1.62l-1.415-6.77Zm-2.16,4.372l.922-2.542.53,2.542h-1.452Z"
                            fill="#fff"
                          ></path>
                          <path
                            fill="#fff"
                            d="M15.894 7.624L14.446 14.394 12.695 14.394 14.143 7.624 15.894 7.624z"
                          ></path>
                        </svg>
                      </div>
                      {/* Mastercard Logo */}
                      <div
                        className="w-10 h-6 bg-white rounded border border-gray-200 flex items-center justify-center"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="20"
                          viewBox="0 0 32 20"
                          style={{ display: "block" }}
                        >
                          <rect
                            x="0"
                            y="2"
                            width="32"
                            height="16"
                            rx="2"
                            fill="#fff"
                            stroke="#ddd"
                            strokeWidth="0.5"
                          ></rect>
                          <path fill="#ff5f00" d="M12.5 6H15.5V14H12.5z"></path>
                          <path
                            d="m12.8,10c0-1.4.6-2.7,1.7-3.6-2-1.6-4.9-1.2-6.5.8-1.6,2-1.2,4.9.8,6.5,1.7,1.3,4,1.3,5.7,0-1.1-.9-1.7-2.2-1.7-3.6Z"
                            fill="#eb001b"
                          ></path>
                          <path
                            d="m20.8,10c0,2.5-2,4.6-4.6,4.6-1,0-2-.3-2.8-1,2-1.6,2.3-4.5.8-6.5-.2-.3-.5-.5-.8-.8,2-1.6,4.9-1.2,6.5.8.6.8,1,1.8,1,2.8Z"
                            fill="#f79e1b"
                          ></path>
                        </svg>
                      </div>
                      {/* Discover Logo */}
                      <div
                        className="w-10 h-6 bg-white rounded border border-gray-200 flex items-center justify-center"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="20"
                          viewBox="0 0 32 20"
                          style={{ display: "block" }}
                        >
                          <rect
                            x="0"
                            y="2"
                            width="32"
                            height="16"
                            rx="2"
                            fill="#fff"
                          ></rect>
                          <path
                            d="m27,2h-8c4.971,0,9,4.029,9,9s-4.029,9-9,9h8c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Z"
                            fill="#f47922"
                          ></path>
                          <path
                            d="m5.081,9.116h-1.081v3.777h1.076c.572,0,.985-.135,1.348-.436.431-.357.686-.894.686-1.45,0-1.115-.833-1.891-2.027-1.891Zm.86,2.837c-.231.209-.532.3-1.008.3h-.198v-2.497h.198c.476,0,.765.085,1.008.305.255.227.408.578.408.94s-.153.725-.408.952Z"
                            fill="#231f20"
                          ></path>
                          <path
                            fill="#231f20"
                            d="M7.448 9.116H8.185V12.893H7.448z"
                          ></path>
                          <path
                            d="m9.986,10.565c-.442-.164-.572-.271-.572-.475,0-.238.231-.419.549-.419.221,0,.402.091.594.306l.386-.505c-.317-.277-.696-.419-1.11-.419-.668,0-1.178.464-1.178,1.082,0,.52.237.787.929,1.036.288.102.435.17.509.215.147.096.221.232.221.391,0,.306-.243.533-.572.533-.351,0-.634-.175-.804-.504l-.476.458c.339.498.747.719,1.308.719.766,0,1.303-.509,1.303-1.24,0-.6-.248-.872-1.086-1.178Z"
                            fill="#231f20"
                          ></path>
                          <path
                            d="m11.305,11.007c0,1.11.872,1.971,1.994,1.971.317,0,.589-.062.924-.22v-.867c-.295.295-.555.414-.889.414-.742,0-1.269-.538-1.269-1.303,0-.725.543-1.297,1.234-1.297.351,0,.617.125.924.425v-.867c-.323-.164-.589-.232-.906-.232-1.116,0-2.011.878-2.011,1.976Z"
                            fill="#231f20"
                          ></path>
                          <path
                            fill="#231f20"
                            d="M20.063 11.653L19.056 9.116 18.251 9.116 19.854 12.99 20.25 12.99 21.882 9.116 21.083 9.116 20.063 11.653z"
                          ></path>
                          <path
                            fill="#231f20"
                            d="M22.215 12.893L24.304 12.893 24.304 12.253 22.951 12.253 22.951 11.234 24.254 11.234 24.254 10.594 22.951 10.594 22.951 9.756 24.304 9.756 24.304 9.116 22.215 9.116 22.215 12.893z"
                          ></path>
                          <path
                            d="m27.221,10.231c0-.707-.487-1.115-1.337-1.115h-1.092v3.777h.736v-1.517h.096l1.02,1.517h.906l-1.189-1.591c.555-.113.861-.492.861-1.071Zm-1.478.624h-.216v-1.144h.227c.459,0,.708.192.708.56,0,.38-.249.584-.72.584Z"
                            fill="#231f20"
                          ></path>
                          <path
                            d="m18.461,11c0,1.105-.895,2-2,2s-2-.895-2-2,.895-2,2-2,2,.895,2,2Z"
                            fill="#f47922"
                          ></path>
                        </svg>
                      </div>
                      {/* American Express Logo */}
                      <div
                        className="w-10 h-6 bg-white rounded border border-gray-200 flex items-center justify-center"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="20"
                          viewBox="0 0 32 20"
                          style={{ display: "block" }}
                        >
                          <rect
                            x="0"
                            y="2"
                            width="32"
                            height="16"
                            rx="2"
                            fill="#0f70ce"
                          ></rect>
                          <path
                            d="m27.026,5l-.719,1.965-.708-1.965h-3.885v2.582l-1.136-2.582h-3.119l-3.259,7.409h2.637v6.591h8.097l1.316-1.458,1.322,1.458h2.244c.112-.314.184-.647.184-1v-1.041l-1.58-1.698,1.58-1.655v-7.606c0-.353-.072-.686-.184-1h-2.79Z"
                            fill="#fff"
                          ></path>
                          <path
                            d="m17.679,10.433h2.61l.502,1.148h1.78l-2.531-5.754h-2.039l-2.531,5.754h1.734l.477-1.148Zm1.307-3.135l.775,1.844h-1.535l.761-1.844Z"
                            fill="#0f70ce"
                          ></path>
                          <path
                            fill="#0f70ce"
                            d="M22.542 5.827L25.018 5.827 26.302 9.39 27.604 5.827 30 5.827 30 11.581 28.45 11.581 28.45 7.603 26.977 11.581 25.608 11.581 24.124 7.631 24.124 11.581 22.542 11.581 22.542 5.827z"
                          ></path>
                          <path
                            fill="#0f70ce"
                            d="M19.24 16.82L19.24 15.944 22.484 15.944 22.484 14.624 19.24 14.624 19.24 13.748 22.565 13.748 22.565 12.409 17.664 12.409 17.664 18.173 22.565 18.173 22.565 16.82 19.24 16.82z"
                          ></path>
                          <path
                            fill="#0f70ce"
                            d="M24.638 12.409L26.271 14.234 27.968 12.409 30 12.409 27.283 15.254 30 18.173 27.939 18.173 26.249 16.309 24.567 18.173 22.537 18.173 25.272 15.275 22.537 12.409 24.638 12.409z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <Form
                  name="billingForm"
                  initialValues={{
                    firstName: userProfile?.firstName || "",
                    lastName: userProfile?.lastName || "",
                    phoneNumber: userProfile?.phoneNumber || "",
                    street1: userProfile?.address?.street1 || "",
                    street2: userProfile?.address?.street2 || "",
                    city: userProfile?.address?.city || "",
                    state: userProfile?.address?.state || "",
                    zipCode: userProfile?.address?.zipCode || "",
                  }}
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  requiredMark={false}
                >
                  {/* Shipping Information Section */}
                  <div className="mb-8">
                    <Typography
                      className="body1"
                      style={{ fontWeight: "bold", marginBottom: "16px" }}
                    >
                      Shipping Information
                    </Typography>
                    <div className="flex gap-4 w-full">
                      <Form.Item
                        name="firstName"
                        rules={[
                          {
                            required: true,
                            message: "What is your first name?",
                          },
                        ]}
                        className="flex-1 mb-0"
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="First Name" />
                      </Form.Item>
                      <Form.Item
                        name="lastName"
                        rules={[
                          {
                            required: true,
                            message: "What is your last name?",
                          },
                        ]}
                        className="flex-1 mb-0"
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="Last Name" />
                      </Form.Item>
                    </div>

                    <div className="flex gap-4 w-full">
                      <Form.Item
                        name="phoneNumber"
                        rules={[
                          {
                            required: true,
                            message: "What is your phone number?",
                          },
                          {
                            pattern: /^\(\d{3}\) \d{3}-\d{4}$/,
                            message: "Please enter a valid phone number",
                          },
                        ]}
                        className="flex-1 mb-0"
                        style={{ marginBottom: 0 }}
                      >
                        <Input
                          placeholder="Phone Number"
                          value={phoneValue}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                            let formatted = value;

                            if (value.length >= 6) {
                              formatted = `(${value.slice(0, 3)}) ${value.slice(
                                3,
                                6
                              )}-${value.slice(6, 10)}`;
                            } else if (value.length >= 3) {
                              formatted = `(${value.slice(0, 3)}) ${value.slice(
                                3
                              )}`;
                            } else if (value.length > 0) {
                              formatted = `(${value}`;
                            }

                            setPhoneValue(formatted);
                            form.setFieldValue("phoneNumber", formatted);
                          }}
                          maxLength={14}
                        />
                      </Form.Item>
                      <div className="flex-1"></div>
                    </div>

                    <Form.Item
                      name="street1"
                      rules={[
                        { required: true, message: "What is your Address1?" },
                      ]}
                    >
                      <Input placeholder="Street1/Address1" />
                    </Form.Item>

                    <Form.Item name="street2">
                      <Input placeholder="Apartment/Suite/Unit" />
                    </Form.Item>

                    <div className="flex gap-4 w-full">
                      <Form.Item
                        name="city"
                        rules={[
                          { required: true, message: "What is your city?" },
                        ]}
                        className="flex-1 mb-0"
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="City" />
                      </Form.Item>
                      <Form.Item
                        name="state"
                        rules={[
                          { required: true, message: "What is your state?" },
                        ]}
                        className="mb-0"
                        style={{ marginBottom: 0, width: "80px" }}
                      >
                        <Input placeholder="State" maxLength={2} />
                      </Form.Item>
                      <Form.Item
                        name="zipCode"
                        rules={[
                          { required: true, message: "What is your zip code?" },
                          {
                            pattern: /^\d{5}(-\d{4})?$/,
                            message:
                              "Please enter a valid zip code (12345 or 12345-6789)",
                          },
                        ]}
                        className="mb-0"
                        style={{ marginBottom: 0, width: "100px" }}
                      >
                        <Input placeholder="Zip Code" maxLength={10} />
                      </Form.Item>
                    </div>
                  </div>

                  {/* Billing Information Section */}
                  <div className="mb-4">
                    <h4 className="h4 mb-4" style={{ textAlign: "left" }}>
                      Billing Information
                    </h4>

                    <div className="mb-4">
                      <p
                        className="body1 mb-4"
                        style={{ color: "var(--theme-text-secondary)" }}
                      >
                        🔒 Your payment is securely processed, and we do not
                        store any credit or debit card information.
                      </p>

                      {/* Card Number */}
                      <Form.Item
                        label={
                          <span className="h6 text-theme-text-secondary">
                            Card Number
                          </span>
                        }
                        className="mb-4"
                      >
                        <div
                          style={{
                            padding: "12px 16px",
                            border: "1px solid #d9d9d9",
                            borderRadius: "6px",
                            backgroundColor: "#fff",
                            fontSize: "14px",
                            lineHeight: "1.5715",
                            color: "rgba(0, 0, 0, 0.88)",
                            transition: "all 0.2s",
                          }}
                        >
                          <CardNumberElement
                            options={{
                              style: {
                                base: {
                                  fontSize: "14px",
                                  color: "rgba(0, 0, 0, 0.88)",
                                  fontFamily:
                                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
                                  "::placeholder": {
                                    color: "rgba(0, 0, 0, 0.25)",
                                  },
                                },
                                invalid: {
                                  color: "#ff4d4f",
                                },
                              },
                            }}
                          />
                        </div>
                      </Form.Item>

                      {/* Expiry and CVC */}
                      <Row gutter={16}>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            label={
                              <span className="h6 text-theme-text-secondary">
                                Expiry Date
                              </span>
                            }
                            className="mb-4"
                          >
                            <div
                              style={{
                                padding: "12px 16px",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                                backgroundColor: "#fff",
                                fontSize: "14px",
                                lineHeight: "1.5715",
                                color: "rgba(0, 0, 0, 0.88)",
                                transition: "all 0.2s",
                              }}
                            >
                              <CardExpiryElement
                                options={{
                                  style: {
                                    base: {
                                      fontSize: "14px",
                                      color: "rgba(0, 0, 0, 0.88)",
                                      fontFamily:
                                        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
                                      "::placeholder": {
                                        color: "rgba(0, 0, 0, 0.25)",
                                      },
                                    },
                                    invalid: {
                                      color: "#ff4d4f",
                                    },
                                  },
                                }}
                              />
                            </div>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            label={
                              <span className="h6 text-theme-text-secondary">
                                CVC
                              </span>
                            }
                            className="mb-4"
                          >
                            <div
                              style={{
                                padding: "12px 16px",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                                backgroundColor: "#fff",
                                fontSize: "14px",
                                lineHeight: "1.5715",
                                color: "rgba(0, 0, 0, 0.88)",
                                transition: "all 0.2s",
                              }}
                            >
                              <CardCvcElement
                                options={{
                                  style: {
                                    base: {
                                      fontSize: "14px",
                                      color: "rgba(0, 0, 0, 0.88)",
                                      fontFamily:
                                        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
                                      "::placeholder": {
                                        color: "rgba(0, 0, 0, 0.25)",
                                      },
                                    },
                                    invalid: {
                                      color: "#ff4d4f",
                                    },
                                  },
                                }}
                              />
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {isError && errors.length > 0 && (
                    <ErrorList errors={errors} />
                  )}
                  <Form.Item>
                    <div className="flex flex-col items-center">
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn-primary btn-lg"
                        style={{ position: 'relative', minWidth: '300px' }}
                      >
                        {isSubmitting ? (
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <Spin size="small" />
                            Processing Payment...
                          </span>
                        ) : (
                          'Submit Payment and Start Telehealth Assessment'
                        )}
                      </button>
                      <div className="mt-4 text-center">
                        <Typography className="body2 text-theme-text-secondary">
                          Assessment takes 10-15 minutes and can be completed on
                          any device with internet
                        </Typography>
                      </div>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default function PaymentPage() {
  return (
    <Elements stripe={stripePromise}>
      <PaymentPageInner />
    </Elements>
  );
}
